export default __webpack_public_path__ + "images/2149071302121b8a8f0658a9bbf7d247.svg";